<template>
  <div id="app">
    <keep-alive>
        <!-- 需要缓存的视图组件 --> 
        <router-view v-if="$route.meta.keepAlive"></router-view>
     </keep-alive>
      <!-- 不需要缓存的视图组件 -->
     <router-view v-if="!$route.meta.keepAlive"></router-view>
  </div>
</template>

<script>
import headers from '@/components/headers'
export default {
  name: 'App',
  components: { headers }
}
</script>

<style lang="scss">
  * { margin: 0; padding: 0 }
  #app {
    font-family: 'Avenir', Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    color: #222;
    width: 100%;
    height: 100%;
    background-color: #f5f5f5;
    font-size: 14px;
  }
  a, a:link, a:visited, a:hover, a:active {
    text-decoration: none;
    color:inherit;
  }
  .public-header {
    margin-top: 10px;
    background-color: #fff;
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    height: 39px;
    padding: 0 15px;
    box-sizing: border-box;
    border-bottom: 1px solid #d8d8d8;
    &-left {
      font-size: 16px;
      color: #222;
      border-left: 2px solid #1cc0da;
      height: 16px;
      line-height: 18px;
      padding-left: 5px;
      span {
        color: #a0a0a0;
      }
    }
    &-right {
      color: #a0a0a0;
      display: flex;
      align-items: center;
      .van-icon {
        vertical-align: -2px;
        color: #a0a0a0;
        display: inline-block;
      }
      span{
        color: #a0a0a0;
      }
    }
  }
  .keywordHighlight{
    color: #1DBFDA !important;
  }
  [v-cloak] {
    display: none;
  }
</style>



// WEBPACK FOOTER //
// src/App.vue